import { useTerminology } from "../../../../lib/terminology.js";
import { type BoxTab, useBoxesSearch } from "./search.js";

export interface BoxTabsContent {
  /** The tab showing. */
  value: BoxTab;
  /** The tab list's accessible name. */
  label: string;
  options: Array<{ value: BoxTab; label: string }>;
  onValueChange: (tab: BoxTab) => void;
}

/** Which boxes the grid shows: all of them, the new ones, or the shopper's favorites. */
export function useBoxTabsContent(): BoxTabsContent {
  const { box } = useTerminology();
  const [search, update] = useBoxesSearch();
  return {
    value: search.tab ?? "all",
    label: `Which ${box.plural} to show`,
    options: [
      { value: "all", label: "All" },
      { value: "new", label: "New" },
      { value: "favorites", label: "Favorites" },
    ],
    onValueChange: (tab) => update({ tab: tab === "all" ? undefined : tab }),
  };
}
